import { Response as GetClientResponse } from '../api/typegen/client/get';
import { routes } from '../routes';

/** Before using this, check whether there's 'REACT_APP_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isLogged = () => Boolean(sessionStorage.getItem('token'));

export const isLogging = () =>
  window.location.pathname === routes.OneTimeTokenLogin;

export const areClientEndpointsReadyToFetch = (
  client?: GetClientResponse | undefined | null,
) => (!isLogged() && !isLogging()) || client !== undefined;

export default isLogged;
